import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";

import i18n from "./i18n.tsx";
import App from "./App.tsx";
import { Provider } from "./provider.tsx";

import "@/styles/globals.css";
import { DirectionLanguageProvider } from "@/components/DirectionLanguageContext.tsx"; // Import provider
import { UserRoleProvider } from "@/context/UserRoleContext";

// Check if we should use HashRouter instead of BrowserRouter
// This can be controlled via an environment variable if needed
const useHashRouter = import.meta.env.VITE_USE_HASH_ROUTER === "true";
const Router = useHashRouter ? HashRouter : BrowserRouter;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Router>
      <DirectionLanguageProvider>
        <I18nextProvider i18n={i18n}>
          <Provider>
            <UserRoleProvider>
              <App />
            </UserRoleProvider>
          </Provider>
        </I18nextProvider>
      </DirectionLanguageProvider>
    </Router>
  </React.StrictMode>,
);
